import { i18n } from "@/i18n";
import UserActivateView from "@/views/User/UserActivateView.vue";

export default {
  path: "/user/form/first-login",
  name: "userActivateRoute",
  component: UserActivateView,
  meta: {
    authRequired: false,
    title: i18n.global.t("dashboard.welcome_to_studea"),
    breadcrumb: false,
  },
};
